import { Helmet } from "react-helmet-async";
import AdSlot from "@/components/ads/AdSlot";

const Methodology = () => {
  return (
    <main className="container mx-auto py-10 space-y-6">
      <Helmet>
        <title>Methodology — U.S. Height Percentiles</title>
        <meta name="description" content="How we compute height percentiles using CDC/NHANES data and weighted empirical CDFs." />
        <link rel="canonical" href={window.location.origin + "/methodology"} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dataset",
            name: "U.S. Adult Height Percentiles (NHANES)",
            description:
              "Percentile distributions derived from CDC/NCHS NHANES Body Measures for U.S. adults (≥20) using weighted empirical CDFs.",
            url: typeof window !== 'undefined' ? window.location.origin + "/methodology" : "https://heightpercentile.com/methodology",
            license: "https://www.cdc.gov/nchs/nhanes/index.htm",
            creator: { "@type": "Organization", name: "CDC/NCHS" },
            citation: "CDC/NCHS. National Health and Nutrition Examination Survey (NHANES): Body Measures.",
          })}
        </script>
      </Helmet>
      <AdSlot slot="banner_top" className="mb-4" />
      <h1>Methodology</h1>
      <p>
        We use CDC/NCHS NHANES Body Measures for U.S. adults (≥20). Percentiles are computed from
        weighted empirical cumulative distribution functions (CDFs). Demo mode uses synthetic normal-like
        data clearly labeled as such.
      </p>
      <AdSlot slot="incontent_1" className="my-6" />
      <h2>Weighting</h2>
      <p>NHANES exam weights are applied. When pooling cycles, weights are normalized per-cycle.</p>
      <h2>Groups</h2>
      <p>We provide male, female, and combined groups. Optional age bands: 20–39, 40–59, 60+.</p>
      <h2>Computation</h2>
      <p>
        Heights are binned on a regular grid (e.g., 0.5 cm). For a user input, we interpolate the percentile
        between grid points. Inputs below/above the grid are softly clamped with a note.
      </p>
      <p className="text-sm text-muted-foreground">Source: CDC/NHANES. This tool is informational only.</p>
    </main>
  );
};

export default Methodology;
